import { render, staticRenderFns } from "./SfSidebar.vue?vue&type=template&id=a8128fc2"
import script from "./SfSidebar.vue?vue&type=script&lang=js"
export * from "./SfSidebar.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfSidebar.vue?vue&type=style&index=0&id=a8128fc2&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "45fe15fa"
  
)

export default component.exports